import range from 'lodash/range';

export default {
  namespaced: true,
  state: {
    months: ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December']
      .map((label, i) => ({
        mm: (i + 1).toString().padStart(2, '0'),
        label,
      })),
    // 1 to 31
    dates: range(1, 32).map(i => i.toString().padStart(2, '0')),
    // last 100 years
    years: range(new Date().getFullYear(), new Date().getFullYear() - 100, -1),
    isMouseDisabled: false,
  },
  actions: {
    setIsMouseDisabled({ state }, value) {
      state.isMouseDisabled = value;
    },
  },
};
